import { useState } from 'react';
import { AuthError, useAuth } from '@/lib/auth';
import { Button, Card, Input } from '@/components/ui';

const MESSAGES: Record<string, string> = {
  'invalid-credentials': 'Hibás felhasználónév vagy jelszó.',
  'server-error': 'A bejelentkezés most nem érhető el. Kérjük próbálja újra.',
};

export function LoginPage() {
  const { login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    setBusy(true);
    try {
      await login(email, password);
    } catch (err) {
      // A wrong password and a dead API are different problems and get
      // different messages; the Angular login showed nothing at all on failure.
      const key = err instanceof AuthError ? err.message : 'server-error';
      setError(MESSAGES[key] ?? MESSAGES['server-error']!);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="flex min-h-screen items-center justify-center px-4">
      <Card className="w-full max-w-sm p-8">
        <h1 className="text-lg font-semibold uppercase tracking-wide text-brand">
          EcoWheels Admin
        </h1>

        <form onSubmit={onSubmit} className="mt-6 space-y-4">
          <div>
            <label htmlFor="email" className="text-sm text-white/80">
              Email
            </label>
            <Input
              id="email"
              type="email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="mt-1"
              required
            />
          </div>

          <div>
            <label htmlFor="password" className="text-sm text-white/80">
              Jelszó
            </label>
            <Input
              id="password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="mt-1"
              required
            />
          </div>

          {error && (
            <p role="alert" className="text-sm text-red-400">
              {error}
            </p>
          )}

          <Button type="submit" disabled={busy} className="w-full">
            {busy ? 'Bejelentkezés…' : 'Bejelentkezés'}
          </Button>
        </form>
      </Card>
    </div>
  );
}
